import React from 'react';

class HostSwitcher extends React.Component {
  constructor(props) {
    super(props)
  }

  handleChange = (e) => {
    window.location.replace("/hostswitcher?to="+e.target.value);
  }

  render() {
    var ret = null;

    var { roots, root } = this.props;

    if (roots) {
      var rootOptions = [];
      roots.forEach((v, i) => {
        rootOptions.push(<option key={"host-switcher-" + i} href="#" value={v}>{v}</option>);
      });

      ret = (
        <div className="btn-group dropup">
          <select value={root}
            onChange={(e)=>this.handleChange(e)}
          >
            {rootOptions}
          </select>
        </div>
      );
    }

    return ret;
  }
}

export { HostSwitcher }
